import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { shuffle } from "lodash";

import * as styles from "./styles.module.css";

const SponsorsSection = ({ sponsors: sponsorsUnshuffled }) => {
    let [sponsors, setSponsors] = useState(sponsorsUnshuffled);
    useEffect(() => {
        setSponsors((sponsors) =>
            shuffle(sponsors).sort((a, b) => a.level - b.level)
        );
    }, []);

    return (
        <div className={styles.sponsorsSection}>
            <h2>Sponsors</h2>
            <div className={styles.sponsorsContainer}>
                {sponsors.map((sponsor) => {
                    const { name, imageName, link, level } = sponsor;

                    const image = imageName ? (
                        <GatsbyImage
                            image={getImage(imageName)}
                            alt={`${name}'s logo`}
                            className={styles.logo}
                        />
                    ) : null;

                    return (
                        <div key={link || name + level}>
                            {link ? (
                                <a href={link} className={styles.logoLink}>
                                    {!!imageName ? image : <h3>{name}</h3>}
                                </a>
                            ) : (
                                <div>
                                    {!!imageName ? image : <h3>{name}</h3>}
                                </div>
                            )}
                            {}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

SponsorsSection.propTypes = {
    sponsors: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            imageName: PropTypes.shape({
                childImageSharp: PropTypes.shape({
                    gatsbyImageData: PropTypes.object.isRequired,
                }).isRequired,
            }),
            link: PropTypes.string,
            level: PropTypes.number,
        })
    ).isRequired,
};

export default SponsorsSection;
